import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 69 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={68}
      height={52}
      transform="translate(0.5)"
      fill="white"
    />
    <rect
      x={33}
      y={14.5}
      width={14}
      height={23}
      rx={1}
      stroke="#29292F"
    />
    <mask
      id="path-2-inside-1_465_26644"
      fill="white"
    >
      <rect
        x={35.5}
        y={17}
        width={9}
        height={16}
        rx={0.75}
      />
    </mask>
    <rect
      x={35.5}
      y={17}
      width={9}
      height={16}
      rx={0.75}
      fill="#FFE6ED"
      stroke="#FFD5E1"
      strokeWidth={2}
      mask="url(#path-2-inside-1_465_26644)"
    />
    <circle
      cx={39.5}
      cy={35}
      r={0.625}
      stroke="#29292F"
      strokeWidth={0.75}
    />
    <rect
      x={54}
      y={21.5}
      width={10}
      height={12}
      rx={1}
      stroke="#29292F"
    />
    <rect
      x={52.5}
      y={23}
      width={2}
      height={3}
      rx={1}
      fill="#29292F"
    />
    <rect
      x={52.5}
      y={26}
      width={2}
      height={3}
      rx={1}
      fill="#29292F"
    />
    <path
      d="M56.5728 19.0447C56.7438 18.7104 57.0876 18.5 57.4632 18.5H60.5368C60.9124 18.5 61.2562 18.7104 61.4272 19.0447L62.6827 21.5H55.3173L56.5728 19.0447Z"
      stroke="#29292F"
    />
    <path
      d="M61.4272 35.9553C61.2562 36.2896 60.9124 36.5 60.5368 36.5L57.4632 36.5C57.0876 36.5 56.7438 36.2896 56.5728 35.9553L55.3173 33.5L62.6827 33.5L61.4272 35.9553Z"
      stroke="#29292F"
    />
    <mask
      id="path-9-inside-2_465_26644"
      fill="white"
    >
      <rect
        x={55.5}
        y={23}
        width={7}
        height={9}
        rx={0.75}
      />
    </mask>
    <rect
      x={55.5}
      y={23}
      width={7}
      height={9}
      rx={0.75}
      fill="#FFE6ED"
      stroke="#FFD5E1"
      strokeWidth={2}
      mask="url(#path-9-inside-2_465_26644)"
    />
    <rect
      x={6}
      y={12.5}
      width={20}
      height={27}
      rx={0.9}
      stroke="#29292F"
    />
    <mask
      id="path-11-inside-3_465_26644"
      fill="white"
    >
      <rect
        x={8.5}
        y={15}
        width={15}
        height={20}
        rx={0.7}
      />
    </mask>
    <rect
      x={8.5}
      y={15}
      width={15}
      height={20}
      rx={0.7}
      fill="#FFE6ED"
      stroke="#FFD5E1"
      strokeWidth={2}
      mask="url(#path-11-inside-3_465_26644)"
    />
    <circle
      cx={16.3008}
      cy={36.5}
      r={0.65}
      stroke="#29292F"
      strokeWidth={0.7}
    />
  </svg>
);
const SvgResponsiveDevice = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgResponsiveDevice;
